import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { updateTNCUrls } from './i18n';

// Fetch runtime configuration
fetch('/runtime-url.json')
  .then(response => response.json())
  .then(urlConfig => {
    // Update TNC URLs
    updateTNCUrls(urlConfig.TNC_EN, urlConfig.TNC_TC);
    
    // Render the app
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById('root')
    );
  })
  .catch(error => {
    console.error('Failed to load runtime configuration:', error);
    // Render the app with default values if config loading fails
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById('root')
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();